import React, { useState, useEffect } from 'react';
import { Box, Button, Paper, Collapse, Alert, Typography } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const YandexMapPicker = ({ latitude, longitude, onCoordinatesChange }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [markerPosition, setMarkerPosition] = useState([
        parseFloat(latitude) || 55.056551,
        parseFloat(longitude) || 82.886962
    ]);

    useEffect(() => {
        const lat = parseFloat(latitude) || 55.056551;
        const lon = parseFloat(longitude) || 82.886962;
        setMarkerPosition([lat, lon]);
    }, [latitude, longitude]);

    const handleSave = () => {
        onCoordinatesChange(markerPosition[0], markerPosition[1]);
        setIsExpanded(false);
    };

    const handleToggle = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <Box sx={{ mt: 2, width: '100%', minWidth: 0 }}>
            <Button
                variant="outlined"
                fullWidth
                onClick={handleToggle}
                startIcon={<LocationOnIcon />}
                sx={{ mb: 1 }}
            >
                {isExpanded ? 'Скрыть карту' : 'Установить координаты'}
            </Button>

            <Collapse in={isExpanded} sx={{ width: '100%' }}>
                <Paper sx={{ p: 2, mt: 2, width: '100%', maxWidth: '100%', boxSizing: 'border-box', overflow: 'hidden' }}>
                    <Alert severity="info" sx={{ mb: 2 }}>
                        Карта временно отключена. Укажи широту и долготу в полях выше.
                    </Alert>

                    <Box sx={{ display: 'flex', gap: 2, mb: 2, width: '100%', minWidth: 0, flexWrap: 'wrap' }}>
                        <Button
                            variant="outlined"
                            onClick={handleSave}
                            sx={{ flex: 1, minWidth: 180 }}
                        >
                            Применить текущие координаты
                        </Button>
                        <Button
                            variant="outlined"
                            onClick={handleToggle}
                            sx={{ flex: 1, minWidth: 180 }}
                        >
                            Отмена
                        </Button>
                    </Box>

                    <Box sx={{ mt: 2, p: 1, bgcolor: 'action.hover', borderRadius: 1 }}>
                        <Typography sx={{ fontSize: '0.875rem', color: 'text.secondary' }}>
                            Текущие координаты:
                        </Typography>
                        <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
                            Широта: {markerPosition[0].toFixed(6)}
                        </Typography>
                        <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
                            Долгота: {markerPosition[1].toFixed(6)}
                        </Typography>
                    </Box>
                </Paper>
            </Collapse>
        </Box>
    );
};

export default YandexMapPicker;
